import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { chimeOn, playBell, setChime } from "@/lib/chime";

export const ChimeToggle = ({ className = "" }) => {
  const [on, setOn] = useState(chimeOn);
  const toggle = (e) => {
    e.stopPropagation();
    setChime(!on);
    if (!on) playBell();
    setOn(!on);
  };
  const Icon = on ? Volume2 : VolumeX;
  return (
    <button data-testid="chime-toggle" aria-pressed={on} onClick={toggle} className={`inline-flex items-center gap-2 rounded-full border border-[#D9B47A]/40 px-4 py-2 font-tt-mono text-[11px] uppercase tracking-[0.2em] text-[#CFC2B6] hover:border-[#D9B47A] hover:text-[#D9B47A] transition-colors ${className}`}>
      <Icon className="w-4 h-4" /> {on ? "Chime on" : "Chime off"}
    </button>
  );
};
